import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext, AppContextMenu } from '../App'
import RequestQueue from '../api/requestQueue'
import { canViewEmployeeIdeas } from './canViewEmployeeIdeas'
import { useAuthResult } from '../hooks/useAuthResult'

const Aside = () => {
    const authResult = useAuthResult()
    const { menu, updateValue } = useContext(AppContextMenu)
    let navigate = useNavigate()
    const handlerExit = () => {
        localStorage.clear()
        navigate('/login')
    }

    const { isTrue, toggleValue } = useContext(AppContext)
    const navigatePage = (url, value) => {
        updateValue(value)
        navigate(url)
        toggleValue()
    }

    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }

    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)

    // کامپوننت آیتم منو برای استفاده مجدد
    const NavItem = ({ active, onClick, icon, title }) => (
        <li>
            <button
                onClick={onClick}
                className={`flex items-center w-full p-4 text-sm transition-all duration-200 ${
                    active
                        ? 'bg-white/10 text-white border-r-4 border-white'
                        : 'text-white/70 hover:bg-white/5 hover:text-white'
                }`}
            >
                <div
                    className={`p-2 rounded-lg ${active ? 'bg-white text-indigo-900' : 'bg-white/10'}`}
                >
                    {icon}
                </div>
                <span className="mr-3 font-medium text-start">{title}</span>
            </button>
        </li>
    )

    return (
        <>
            {/* دکمه همبرگر برای موبایل با بک‌گراند و لوگو */}
            <div className="md:hidden fixed top-0 right-0 left-0 z-50 bg-indigo-900/90 backdrop-blur-sm px-4 py-2 flex items-center justify-between shadow-md">
                <h1 className="text-xl font-bold text-white">
                    <span className="bg-white text-indigo-900 px-2 py-1 rounded-lg">
                        P-B-Q
                    </span>
                </h1>
                <button
                    className="bg-white/20 p-2 rounded-lg shadow-lg"
                    onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
                >
                    {isMobileNavOpen ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                        </svg>
                    )}
                </button>
            </div>

            {/* نوار کناری اصلی */}
            <aside
                className={`fixed inset-y-0 right-0 z-40 w-full md:w-64 bg-gradient-to-b from-indigo-900 to-purple-900 shadow-xl transform transition-transform duration-300 ease-in-out ${
                    isMobileNavOpen
                        ? 'translate-x-0'
                        : 'translate-x-full md:translate-x-0'
                }`}
                dir="rtl"
            >
                {/* هدر با لوگو - فقط در دسکتاپ نمایش داده می‌شود */}
                <div className="hidden md:flex p-6 border-b border-white/10 items-center justify-center">
                    <h1 className="text-2xl font-bold text-white flex items-center">
                        <span className="bg-white text-indigo-900 px-2 py-1 rounded-lg">
                            P-B-Q
                        </span>
                    </h1>
                </div>

                {/* اطلاعات کاربر */}
                <div className="p-4 border-b border-white/10 flex items-center mt-16 md:mt-0">
                    <div className="relative">
                        <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                />
                            </svg>
                        </div>
                        <div className="absolute bottom-0 left-0 w-3 h-3 bg-green-500 rounded-full border-2 border-indigo-900"></div>
                    </div>
                    <div className="mr-3">
                        <p className="text-white font-medium">
                            {RequestQueue.getAuthResult()?.user?.full_name ||
                                'کاربر'}
                        </p>
                        <p className="text-white/60 text-xs">
                            {RequestQueue.getAuthResult()?.user?.role
                                ?.nick_name || 'نقش کاربری'}
                        </p>
                    </div>
                </div>

                {/* لیست کامل منوها */}
                <nav className="overflow-y-auto h-[calc(100%-180px)] py-4">
                    <ul className="space-y-1 px-2">
                        {/* داشبورد */}
                        <NavItem
                            active={menu === 'dashboard'}
                            onClick={() => {
                                navigatePage('/', 'dashboard')
                                setIsMobileNavOpen(false)
                            }}
                            icon={
                                <svg
                                    width={22}
                                    height={23}
                                    viewBox="0 0 22 23"
                                    fill="currentColor"
                                >
                                    <path d="M9.23201 3.4202L9.23239 3.41989C10.2108 2.63408 11.7843 2.63834 12.7781 3.42994C12.7783 3.43005 12.7784 3.43015 12.7785 3.43025L18.7784 8.2301C18.7789 8.23054 18.7795 8.23099 18.78 8.23143C19.1189 8.50835 19.4146 8.94381 19.6058 9.44415C19.7968 9.94409 19.8672 10.4662 19.8014 10.8985L18.6475 17.8037C18.6474 17.8042 18.6473 17.8047 18.6472 17.8052C18.4217 19.0989 17.1608 20.1667 15.8585 20.1667H6.1418C4.81982 20.1667 3.58766 19.1252 3.36227 17.8148C3.36221 17.8145 3.36215 17.8142 3.36209 17.8138L2.20746 10.9043L2.20726 10.9032C2.13345 10.4677 2.19947 9.94466 2.39002 9.44498C2.58055 8.94535 2.87982 8.51038 3.22697 8.2334L3.22784 8.2327L9.23201 3.4202ZM11.0001 18.1876C11.6521 18.1876 12.1876 17.652 12.1876 17.0001V14.2501C12.1876 13.5981 11.6521 13.0626 11.0001 13.0626C10.3482 13.0626 9.81263 13.5981 9.81263 14.2501V17.0001C9.81263 17.652 10.3482 18.1876 11.0001 18.1876Z" />
                                </svg>
                            }
                            title="داشبورد"
                        />

                        {/* کاربران */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.users && (
                            <NavItem
                                active={menu === 'users'}
                                onClick={() => {
                                    navigatePage('/users', 'users')
                                    setIsMobileNavOpen(false)
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                                        />
                                    </svg>
                                }
                                title="مدیریت کاربران"
                            />
                        )}
                        {/* پروفایل */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.userProfile && (
                            <NavItem
                                active={menu === 'userProfile'}
                                onClick={() =>
                                    navigatePage('/userProfile', 'userProfile')
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        />
                                    </svg>
                                }
                                title="پروفایل کاربری"
                            />
                        )}

                        {/* درخواست‌های در حال انتظار دیگران */}
                        <NavItem
                            active={menu === 'furloughGet'}
                            onClick={() =>
                                navigatePage('/furloughGet', 'furloughGet')
                            }
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                    />
                                </svg>
                            }
                            title="درخواست‌های در حال انتظار دیگران"
                        />
                        {/* تاریخچه مرخصی‌های من */}
                        <NavItem
                            active={menu === 'furlough'}
                            onClick={() =>
                                navigatePage('/furlough', 'furlough')
                            }
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                </svg>
                            }
                            title="تاریخچه مرخصی‌های من"
                        />

                        {/* تاریخچه همه مرخصی‌ها */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.furlough_all && (
                            <NavItem
                                active={menu === 'furloughGetManagment'}
                                onClick={() =>
                                    navigatePage(
                                        '/furloughGetManagment',
                                        'furloughGetManagment'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                        />
                                    </svg>
                                }
                                title={
                                    RequestQueue.getAuthResult()?.user?.role
                                        .name === 'employee'
                                        ? 'تاریخچه مرخصی دیگران'
                                        : 'تاریخچه همه مرخصی‌ها'
                                }
                            />
                        )}

                        {/* ارسال پیام ناشناس */}
                        <NavItem
                            active={menu === 'sendAnonymousMessage'}
                            onClick={() =>
                                navigatePage(
                                    '/sendAnonymousMessage',
                                    'sendAnonymousMessage'
                                )
                            }
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                                    />
                                </svg>
                            }
                            title="ارسال پیام ناشناس"
                        />

                        {/* پیام‌های ناشناس */}
                        {RequestQueue.getAuthResult()?.user
                            ?.is_anonymous_message && (
                            <NavItem
                                active={menu === 'anonymousMessage'}
                                onClick={() =>
                                    navigatePage(
                                        '/anonymousMessage',
                                        'anonymousMessage'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                                        />
                                    </svg>
                                }
                                title="پیام‌های ناشناس"
                            />
                        )}

                        <NavItem
                            active={menu === 'sendEmployeeIdea'}
                            onClick={() =>
                                navigatePage(
                                    '/sendEmployeeIdea',
                                    'sendEmployeeIdea'
                                )
                            }
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                    />
                                </svg>
                            }
                            title="ثبت ایده"
                        />

                        {canViewEmployeeIdeas(authResult) && (
                            <NavItem
                                active={menu === 'employeeIdeas'}
                                onClick={() =>
                                    navigatePage(
                                        '/employeeIdeas',
                                        'employeeIdeas'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                        />
                                    </svg>
                                }
                                title="ایده‌های ثبت‌شده"
                            />
                        )}

                        {/* گزارش کلی */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.reports && (
                            <NavItem
                                active={menu === 'reports'}
                                onClick={() =>
                                    navigatePage('/reports', 'reports')
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                        />
                                    </svg>
                                }
                                title="گزارش کلی"
                            />
                        )}

                        {/* چینش سازمان */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.dp_organizations && (
                            <NavItem
                                active={menu === 'organizationLayout'}
                                onClick={() =>
                                    navigatePage(
                                        '/organizationLayout',
                                        'organizationLayout'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
                                        />
                                    </svg>
                                }
                                title="چینش سازمان"
                            />
                        )}

                        {/* مسیر مرخصی */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.furlough_routes && (
                            <NavItem
                                active={menu === 'furloughRoutes'}
                                onClick={() =>
                                    navigatePage(
                                        '/furloughRoutes',
                                        'furloughRoutes'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                                        />
                                    </svg>
                                }
                                title="مسیر مرخصی"
                            />
                        )}

                        {/* سازمان */}
                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <NavItem
                                active={menu === 'organization'}
                                onClick={() =>
                                    navigatePage(
                                        '/organization',
                                        'organization'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                        />
                                    </svg>
                                }
                                title="سازمان"
                            />
                        )}

                        {RequestQueue.getAuthResult()?.user?.role?.abilities
                            ?.organizations && (
                            <NavItem
                                active={menu === 'organizationShift'}
                                onClick={() =>
                                    navigatePage(
                                        '/organizationShift',
                                        'organizationShift'
                                    )
                                }
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                        />
                                    </svg>
                                }
                                title="شیفت"
                            />
                        )}
                        <NavItem
                            onClick={handlerExit}
                            icon={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    />
                                </svg>
                            }
                            title="خروج از سیستم"
                        />
                    </ul>
                </nav>
            </aside>

            {/* overlay برای موبایل */}
            {isMobileNavOpen && (
                <div
                    className="fixed inset-0 z-30 bg-black/70 md:hidden"
                    onClick={() => setIsMobileNavOpen(false)}
                />
            )}
        </>
    )
}

export default Aside
